<span matDialogTitle>
  {{ 'Esport template' | siaTranslate }}
</span>

<button mat-icon-button matDialogClose>
  <mat-icon>close</mat-icon>
</button>
<div class="p-4" matDialogContent>
  <sia-json-editor [(jsonCode)]="data" [readOnly]="true"></sia-json-editor>
</div>
<div matDialogActions align="end">
  <button mat-button (click)="download()">
    {{ 'Scarica' | siaTranslate }}
  </button>
</div>
